﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Web3Controller = void 0;
const AppControllerBase_1 = require("./AppControllerBase");
const App_1 = require("../App");
const PriceKeeperContract_1 = require("../contracts/PriceKeeperContract");
const UpManagerContract_1 = require("../contracts/UpManagerContract");
const LiquidControllerContract_1 = require("../contracts/LiquidControllerContract");
const BuyBurnPoolContract_1 = require("../contracts/BuyBurnPoolContract");
const StabilityPoolContract_1 = require("../contracts/StabilityPoolContract");
const InternalExchangerBnBContract_1 = require("../contracts/InternalExchangerBnBContract");
const InternalExchangerSPContract_1 = require("../contracts/InternalExchangerSPContract");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const ShareXContract_1 = require("../contracts/ShareXContract");
const BurnableContract_1 = require("../contracts/BurnableContract");
const ValidatorFeeReceiverContract_1 = require("../contracts/ValidatorFeeReceiverContract");
const ValidatorStatsCollectorContract_1 = require("../contracts/ValidatorStatsCollectorContract");
const ValidatorBnBContract_1 = require("../contracts/ValidatorBnBContract");
class Web3Controller extends AppControllerBase_1.AppControllerBase {
    constructor(app) {
        super(app);
        this._liquidControllers = [];
    }
    get isConnected() { return this._web3 != undefined; }
    get web3() { return this._web3; }
    get account() { return this._account; }
    get addressTokenUSDL() { return this._addressTokenUSDL; }
    get addressTokenLOAN() { return this._addressTokenLOAN; }
    get addressTokenUP() { return this._addressTokenUP; }
    get addressPriceKeeperPLS() { return this._addressPriceKeeperPLS; }
    get addressPriceKeeperUP() { return this._addressPriceKeeperUP; }
    get internalExchangerBnB() { return this._internalExchangerBnB; }
    get internalExchangerSP() { return this._internalExchangerSP; }
    get priceKeeperPLS() { return this._priceKeeperPLS; }
    get priceKeeperUP() { return this._priceKeeperUP; }
    get upManager() { return this._upManager; }
    get buyBurnPool() { return this._buyBurnPool; }
    get stabilityPool() { return this._stabilityPool; }
    get burnableUp() { return this._burnableUp; }
    get shareX() { return this._shareX; }
    get liquidControllers() { return this._liquidControllers.slice(); }
    get validatorsManager() { return this._validatorsManager; }
    get validatorsStats() { return this._validatorsStats; }
    get validatorsBnB() { return this._validatorsBnB; }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.initWeb3();
        });
    }
    getAccountAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._account)
                return this._account;
            const eth = globalThis.ethereum;
            //chain validation
            const currentChainId = yield eth.request({ method: 'eth_chainId' });
            if (currentChainId != 369) {
                new modalCom.DialogOk("Wrong blockchain selected. Change blockchain and refresh page.").show();
                return;
            }
            const accounts = yield eth.request({ method: 'eth_requestAccounts' });
            this._account = accounts[0];
            this._web3 = new globalThis.Web3(eth);
            this._upManager.updateWeb3(this._web3);
            this._priceKeeperPLS.updateWeb3(this._web3);
            this._priceKeeperUP.updateWeb3(this._web3);
            this._buyBurnPool.updateWeb3(this._web3);
            this._stabilityPool.updateWeb3(this._web3);
            this._shareX.updateWeb3(this._web3);
            this._burnableUp.updateWeb3(this._web3);
            this._validatorsManager.updateWeb3(this._web3);
            this._validatorsStats.updateWeb3(this._web3);
            this._validatorsBnB.updateWeb3(this._web3);
            for (const contract of this._liquidControllers)
                contract.updateWeb3(this._web3);
        });
    }
    initWeb3() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._web3 = new globalThis.Web3(new globalThis.Web3.providers.HttpProvider("https://rpc.pulsechain.com"));
                this._upManager = new UpManagerContract_1.UpManagerContract(App_1.App.ADDRESS_upManager, this._web3);
                this._validatorsManager = new ValidatorFeeReceiverContract_1.ValidatorFeeReceiverContract(App_1.App.ADDRESS_upValidatorsFee, this._web3);
                const validatorStatsAddress = yield this._validatorsManager.getStatsCollectorAddress();
                this._validatorsStats = new ValidatorStatsCollectorContract_1.ValidatorStatsCollectorContract(validatorStatsAddress, this._web3);
                const validatorBnBStatsAddress = yield this._validatorsManager.getBnbAddress();
                this._validatorsBnB = new ValidatorBnBContract_1.ValidatorBnBContract(validatorBnBStatsAddress, this._web3);
                this._addressPriceKeeperPLS = yield this._upManager.getPriceKeeperPLS();
                this._addressPriceKeeperUP = yield this._upManager.getPriceKeeperUP();
                this._addressTokenUSDL = yield this._upManager.getTokenUSDL();
                this._addressTokenLOAN = yield this._upManager.getTokenLOAN();
                this._addressTokenUP = yield this._upManager.getTokenUP();
                this._priceKeeperPLS = new PriceKeeperContract_1.PriceKeeperContract(this.addressPriceKeeperPLS, this._web3);
                this._priceKeeperUP = new PriceKeeperContract_1.PriceKeeperContract(this.addressPriceKeeperUP, this._web3);
                this._buyBurnPool = new BuyBurnPoolContract_1.BuyBurnPoolContract(yield this._upManager.getBuyBurnPool(), this._web3);
                this._stabilityPool = new StabilityPoolContract_1.StabilityPoolContract(yield this._upManager.getStabilityPool(), this._web3);
                this._internalExchangerBnB = new InternalExchangerBnBContract_1.InternalExchangerBnBContract(yield this._upManager.getInternalExchangerBnB(), this._web3);
                this._internalExchangerSP = new InternalExchangerSPContract_1.InternalExchangerSPContract(yield this._upManager.getInternalExchangerSP(), this._web3);
                this._burnableUp = new BurnableContract_1.BurnableContract(this._addressTokenUP, this._web3);
                this._shareX = new ShareXContract_1.ShareXContract(yield this._upManager.getRewardPool(), this._web3);
                if (yield this._upManager.getStarted()) {
                    const firstVault = yield this._upManager.getLiquidController(0);
                    if (firstVault.count != 0)
                        this._liquidControllers.push(new LiquidControllerContract_1.LiquidControllerContract(firstVault.liquidController, this._web3, 0));
                    let i = 1;
                    while (i < firstVault.count) {
                        const data = yield this._upManager.getLiquidController(i);
                        this._liquidControllers.push(new LiquidControllerContract_1.LiquidControllerContract(data.liquidController, this._web3, i));
                        i++;
                    }
                }
            }
            catch (e) {
                new modalCom.DialogOk(e).show();
            }
        });
    }
    ethToFormat(eth, del = 3) {
        //del - сколько знаков после запятой справа будет после череды нулей
        if (eth == "0.")
            return "0";
        const spliter = eth.split('.');
        let a = spliter[0];
        let result = "";
        let c = 0;
        for (let i = a.length - 1; i >= 0; i--) {
            result = a[i] + result;
            c++;
            if (c % 3 == 0 && i != 0) {
                result = "," + result;
            }
        }
        if (spliter.length == 1)
            return result;
        if (del == 0)
            return result;
        let b = spliter[1];
        if (b.length == 1)
            b = b + "0";
        let tb = "";
        let bc = 0;
        for (let i = 0; i < b.length; i++) {
            if (bc < del)
                tb += b[i];
            if (bc == 0 && b[i] == "0")
                continue;
            bc++;
        }
        b = tb;
        if (result.length < 2)
            return result + "." + b;
        else
            return result + "." + b.slice(0, 2);
    }
}
exports.Web3Controller = Web3Controller;
//# sourceMappingURL=Web3Controller.js.map